<template>
    <div
        v-if="visible"
        class="fixed inset-0 z-[3001] items-center justify-center bg-black/70"
        :class="[pendingOrderVisible ? 'hidden' : 'flex']"
        @click.self="handleClose"
    >
        <div
            class="relative bg-[#22242D] rounded-[20px] px-5 py-[50px] w-[320px] md:w-[400px] lg:w-[520px] mx-4 shadow-2xl"
            @click.stop
        >
            <button
                @click="handleClose"
                class="absolute top-4 right-4 w-6 h-6 flex items-center justify-center text-white hover:scale-105 hover:rotate-180 transition-all duration-200"
            >
                <img
                    src="@/assets/images/common/_close.webp"
                    alt="close"
                    class="w-[24px]"
                />
            </button>

            <div v-if="result_loading" class="text-center">
                <div class="flex justify-center pay-loading">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="132"
                        height="132"
                        viewBox="0 0 132 132"
                        fill="none"
                    >
                        <circle
                            cx="66"
                            cy="66"
                            r="66"
                            fill="#44EB8F"
                            fill-opacity="0.3"
                        />
                        <circle
                            cx="66"
                            cy="66"
                            r="56.375"
                            fill="#44EB8F"
                            fill-opacity="0.7"
                        />
                        <circle cx="66" cy="66" r="45.375" fill="#44EB8F" />
                        <path
                            d="M83.0334 53.4412C82.5112 52.9574 81.8277 52.7155 81.1474 52.7155C81.0668 52.7155 81.0265 52.7155 80.9469 52.7155C80.9065 52.7155 80.465 52.756 79.7826 52.756C78.6184 52.756 76.4119 52.675 74.2861 52.1518C71.5565 51.5082 68.3863 48.4861 67.463 47.8808C67.0226 47.5984 66.4601 47.4375 65.9379 47.4375C65.4168 47.4375 64.8957 47.5984 64.4139 47.8808C64.294 47.9618 61.0039 51.3856 57.7935 52.1518C55.6666 52.675 53.3795 52.756 52.2567 52.756C51.5339 52.756 51.0935 52.7155 51.0531 52.7155C51.0128 52.7155 50.9321 52.7155 50.8929 52.7155C50.1701 52.7155 49.528 52.9574 49.0069 53.4412C48.4455 53.925 48.125 54.6497 48.125 55.3753V62.0621C48.125 86.7196 64.7758 89.9005 65.4582 90.022C65.6185 90.0625 65.7798 90.0625 65.939 90.0625C66.0992 90.0625 66.2616 90.0625 66.4219 90.022C67.1436 89.9005 83.875 86.7186 83.875 62.0621V55.3753C83.875 54.6497 83.5524 53.925 83.0334 53.4412ZM76.8534 62.9903L65.3372 74.1889C65.2566 74.3104 65.177 74.4319 65.056 74.5129C64.7344 74.8347 64.294 74.9956 63.8525 74.9956C63.4099 74.9956 62.9694 74.8347 62.6086 74.5129C62.5279 74.4319 62.4091 74.3115 62.3677 74.1889L56.1888 68.1863C55.5467 67.5416 55.5467 66.5356 56.1888 65.8909C56.8298 65.2452 57.9134 65.2452 58.5555 65.8909L63.8525 71.007L74.4856 60.6939C75.1691 60.0492 76.2103 60.0492 76.8524 60.6939C77.5348 61.2981 77.5348 62.3456 76.8534 62.9903Z"
                            fill="white"
                        />
                    </svg>
                </div>

                <p class="text-white text-2xl font-medium leading-relaxed mt-5">
                    {{ t('pricing.payResult.loading') }}
                </p>
                <p class="text-white text-[13px] leading-relaxed mt-[5px]">
                    {{ t('order_modal.paymentInformationIsSafe') }}
                </p>
            </div>
            <!-- v-if="!result_loading" -->
            <div v-if="!result_loading" class="mt-4 text-center">
                <div
                    v-if="['PAYED', 'SUCCESS'].includes(pay_result_status)"
                    class="flex flex-col items-center justify-center"
                >
                    <img
                        src="https://static.weryai.com/growth/image/06a1a2c8fbff605b85778d4aab9cc7c2.webp"
                        alt="success"
                        class="w-[132px] h-[132px]"
                    />
                    <p
                        class="text-white text-2xl font-medium leading-relaxed mt-5"
                    >
                        {{ t('pricing.payResult.success') }}
                    </p>
                    <button
                        class="w-[60%] mt-[30px] flex items-center justify-center gap-2 px-6 py-3 h-[44px] rounded-[10px] font-semibold text-base transition-all duration-300 bg-create-btn text-black hover:brightness-110 hover:scale-105"
                        @click="handleNavigateToCreate"
                    >
                        {{ buttonText }}
                    </button>
                </div>
                <div v-else class="flex flex-col items-center justify-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="132"
                        height="132"
                        viewBox="0 0 132 132"
                        fill="none"
                        class="shake-animation"
                    >
                        <circle
                            cx="66"
                            cy="66"
                            r="66"
                            fill="#F55D5D"
                            fill-opacity="0.3"
                        />
                        <circle
                            cx="66"
                            cy="66"
                            r="56.375"
                            fill="#F55D5D"
                            fill-opacity="0.7"
                        />
                        <circle cx="66" cy="66" r="45.375" fill="#F55D5D" />
                        <path
                            d="M66 45C54.4021 45 45 54.4021 45 66.0001C45 77.598 54.4021 87 66 87C77.5979 87 87 77.5979 87 66.0001C87 54.4021 77.5979 45 66 45ZM66 81.9601C64.067 81.9601 62.5 80.342 62.5 78.3461C62.5 76.3502 64.067 74.732 66 74.732C67.9329 74.732 69.4999 76.3501 69.4999 78.3461C69.4999 80.342 67.9329 81.9601 66 81.9601ZM68.7177 68.9498C68.7177 70.9457 67.6115 72.5637 66.2471 72.5637H65.753C64.3885 72.5637 63.2824 70.9457 63.2824 68.9498L61.8 54.494C61.8 52.498 62.9061 50.8801 64.2706 50.8801H67.7294C69.0939 50.8801 70.2 52.4981 70.2 54.494L68.7177 68.9498Z"
                            fill="white"
                        />
                    </svg>
                    <p
                        class="text-white text-2xl font-medium leading-relaxed mt-5"
                    >
                        {{ t('order_modal.pay_failed') }}
                    </p>
                    <p class="text-white text-[13px] leading-relaxed mt-1">
                        {{ t('order_modal.pay_failed_notice') }}
                    </p>
                    <button
                        class="w-[60%] mt-[30px] flex items-center justify-center gap-2 px-6 py-3 h-[44px] rounded-[10px] font-semibold text-base transition-all duration-300 bg-create-btn text-black hover:brightness-110 hover:scale-105"
                        @click="handleChangePaymentMethod"
                    >
                        {{ t('order_modal.change_payment_method') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from '~/composables/useI18n'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { emitter, emitOpenAirwallexPayModal } from '~/utils/emitter'
import { useUserStore } from '~/stores/user'
import { getRechargeResultApi } from '~/api/common'
import { useRoute } from '#imports'
import { useAppStore } from '~/stores/app'
import { useApiStore } from '~/stores/api'

const userStore = useUserStore()
const appStore = useAppStore()
const apiStore = useApiStore()
const pay_result_status = ref<string>('')
const result_loading = ref<boolean>(true)
const visible = defineModel<boolean>('visible', { required: true })
const pendingOrderVisible = defineModel<boolean>('pendingOrderVisible', {
    required: true,
})
const query_biz_order_id = ref<string>('')
const pay_price = ref<number>(0) // 保存支付金额
const status_text = computed(() => {
    if (['PAYED', 'SUCCESS'].includes(pay_result_status.value)) {
        return t('pricing.payResult.success')
    } else {
        return t('pricing.payResult.failed')
    }
})

const { t } = useI18n()

/**
 * 处理关闭弹窗
 */
const handleClose = () => {
    visible.value = false
    result_loading.value = true
}

const showVisible = (data: any) => {
    visible.value = true
    const { status, loading, biz_order_id, price, price_show } = data
    // pay_result_status.value = status
    // result_loading.value = loading
    query_biz_order_id.value = biz_order_id
    // 保存支付金额
    if (price !== undefined && price !== null) {
        pay_price.value = price || price_show
    }
}

const handleNavigateToCreate = () => {
    handleClose()
    // 聊天页面只关闭弹窗，不跳转
    if (!isFromChatPage.value) {
        navigateTo('/image-to-video')
    }
}

const handleChangePaymentMethod = async () => {
    // 查询最近一条待支付记录
    emitter.emit('show-pending-order')

    handleClose()
}

const route = useRoute()

// 判断是否来自聊天页面
const isFromChatPage = computed(() => {
    const path = route.path
    // 检查是否直接是 /chat 开头（英文默认路径）
    if (path.startsWith('/chat')) {
        return true
    }
    // 检查是否是带语言前缀的聊天路径，如 /zh/chat, /ja/chat 等
    // 匹配格式：/[2个字母语言代码]/chat
    const multilingualChatPattern = /^\/[a-z]{2}\/chat(?:\/|$)/i
    return multilingualChatPattern.test(path)
})

// 按钮文案：聊天页面显示"继续聊天"，其他页面显示"去创作"
const buttonText = computed(() => {
    return isFromChatPage.value
        ? t('order_modal.continue_chat')
        : t('order_modal.go_to_create')
})

// 在支付查询失败的情况下 清空订单id
const resetUrlPayStatus = (status: string) => {
    if (['SUCCESS', 'PAYED'].includes(status)) {
        pendingOrderVisible.value = false
        emitter.emit('refresh-goods-data')
    }
    if (query_biz_order_id.value) {
        setTimeout(() => {
            apiStore.fetchBalance()
            userStore.getBalance()
            userStore.getAccountSummary()
            appStore.getRecentCreatedOrder()
        }, 1500)

        const new_url = location.origin + location.pathname
        const currentUrl = new URL(new_url)
        currentUrl.searchParams.delete('biz_order_id')
        // 使用 history.replaceState 更新URL而不进行页面跳转
        window.history.replaceState({}, '', currentUrl.toString())
    }
}

const timer = ref<any>(null)
const pollCount = ref(0)
const startTime = ref(0)
// 用于防止重复上报的 Set，存储已上报的订单ID
const reportedOrderIds = ref<Set<string>>(new Set())

// 支付状态枚举
const PAYMENT_STATUS = {
    PENDING: 'PENDING',
    CREATED: 'CREATED',
    SUCCESS: 'SUCCESS',
    PAYED: 'PAYED',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
    TIMEOUT: 'TIMEOUT',
} as const

// 轮询配置
const POLLING_CONFIG = {
    INTERVAL: 5000, // 5秒轮询一次
    MAX_ATTEMPTS: 720, // 最多轮询720次（720*5=3600秒=60分钟）
    TIMEOUT: 3600000, // 60分钟超时
} as const

// 清理定时器
const clearPollingTimer = () => {
    if (timer.value) {
        clearInterval(timer.value)
        timer.value = null
    }
}

// 检查是否超时
const isTimeout = (): boolean => {
    return Date.now() - startTime.value > POLLING_CONFIG.TIMEOUT
}

// 检查是否达到最大轮询次数
const isMaxAttemptsReached = (): boolean => {
    return pollCount.value >= POLLING_CONFIG.MAX_ATTEMPTS
}

// 发送支付成功埋点
const sendPaySuccessEvent = async (
    paymentData: any,
    orderId: string | number
) => {
    if (import.meta.client && typeof window !== 'undefined') {
        // 使用订单ID作为唯一标识，防止重复上报
        const orderIdStr = String(orderId)

        // 检查是否已经上报过（内存中检查，防止并发调用）
        if (reportedOrderIds.value.has(orderIdStr)) {
            console.log(`订单 ${orderIdStr} 已上报过埋点，跳过`)
            return
        }

        try {
            const { analyticsEvent } = await import('~/utils/log-event-func')
            // 优先使用保存的价格，如果没有再尝试从 API 返回数据中获取
            const price =
                pay_price.value ||
                paymentData?.amount ||
                paymentData?.price ||
                paymentData?.total_amount ||
                0
            const pay_goods_id = localStorage.getItem('pay_goods_id')
            const pay_payment_types = localStorage.getItem(
                pay_goods_id + '_pay_payment_types'
            )
            const pay_price_local = localStorage.getItem(
                pay_goods_id + '_pay_price'
            )
            const has_send_pay_result = localStorage.getItem(
                pay_goods_id + '_has_send_pay_result'
            )

            // 双重检查：同时检查内存和 localStorage
            if (pay_goods_id && has_send_pay_result === 'false') {
                // 立即标记为已上报，防止并发调用
                reportedOrderIds.value.add(orderIdStr)
                console.log(pay_price_local, price)

                // 发送埋点
                analyticsEvent('pay_result_suc', {
                    price: pay_price_local || price,
                    order_id: pay_goods_id,
                    payment_types: pay_payment_types,
                })

                // 清理 localStorage（在发送成功后清理）
                localStorage.removeItem('pay_goods_id')
                localStorage.removeItem(pay_goods_id + '_pay_payment_types')
                localStorage.removeItem(pay_goods_id + '_pay_price')
                localStorage.removeItem(pay_goods_id + '_has_send_pay_result')

                console.log(`订单 ${orderIdStr} 支付成功埋点已上报`)
            } else {
                // 如果 localStorage 中标记已发送，也加入内存 Set，防止后续重复检查
                if (has_send_pay_result === 'true') {
                    reportedOrderIds.value.add(orderIdStr)
                }
            }
        } catch (error) {
            // 如果发送失败，从 Set 中移除，允许重试
            reportedOrderIds.value.delete(orderIdStr)
            console.error('支付成功埋点上报失败:', error)
        }
    }
}

const handlePayResultPolling = async (order_id: string | number | null) => {
    if (!order_id) {
        console.error('缺少订单ID参数')
        return
    }

    startTime.value = Date.now()
    pollCount.value = 0

    console.log(`开始轮询支付结果，订单ID: ${order_id}`)
    // 先查一次支付结果
    const { status, data } = await getRechargeResultApi(
        order_id as string | number
    )
    if (status === 200) {
        const is_end = ['SUCCESS', 'PAYED', 'FAILED', 'CANCELLED'].includes(
            data.status
        )
        if (is_end) {
            pay_result_status.value = data.status

            // 如果支付成功，发送埋点（异步非阻塞）
            if (['SUCCESS', 'PAYED'].includes(data.status)) {
                console.log('支付成功')
                sendPaySuccessEvent(data, order_id) // 不使用 await，避免阻塞主流程
            }

            result_loading.value = false
            resetUrlPayStatus(pay_result_status.value)
            return
        }
    }

    timer.value = setInterval(async () => {
        pollCount.value++

        // 检查是否超时或达到最大轮询次数
        if (isTimeout() || isMaxAttemptsReached()) {
            console.log('支付轮询超时或达到最大次数，停止轮询')
            clearPollingTimer()
            pay_result_status.value = PAYMENT_STATUS.TIMEOUT
            result_loading.value = false
            resetUrlPayStatus(PAYMENT_STATUS.TIMEOUT)
            return
        }

        try {
            const { status, data } = await getRechargeResultApi(
                order_id as string | number
            )

            if (status === 200 && data) {
                const paymentStatus = data.status
                pay_result_status.value = paymentStatus
                result_loading.value = [
                    'SUCCESS',
                    'PAYED',
                    'FAILED',
                    'CANCELLED',
                ].includes(paymentStatus)
                    ? false
                    : true
                switch (paymentStatus) {
                    case PAYMENT_STATUS.SUCCESS:
                    case PAYMENT_STATUS.PAYED:
                        console.log('支付成功')

                        // 发送埋点（异步非阻塞）
                        sendPaySuccessEvent(data, order_id) // 不使用 await，避免阻塞主流程

                        clearPollingTimer()
                        resetUrlPayStatus(PAYMENT_STATUS.SUCCESS)
                        break

                    case PAYMENT_STATUS.FAILED:
                        console.log('支付失败')
                        clearPollingTimer()
                        resetUrlPayStatus(PAYMENT_STATUS.FAILED)
                        break

                    case PAYMENT_STATUS.CANCELLED:
                        console.log('支付已取消')
                        clearPollingTimer()
                        resetUrlPayStatus(PAYMENT_STATUS.CANCELLED)
                        break

                    case PAYMENT_STATUS.PENDING:
                    case PAYMENT_STATUS.CREATED:
                        console.log('支付处理中，继续轮询...')
                        // 继续轮询
                        break

                    default:
                        console.warn('未知的支付状态:', pay_result_status.value)
                        // 对于未知状态，继续轮询
                        break
                }
            } else {
                console.warn('API返回异常状态:', status)
                // API返回异常状态时，继续轮询
            }
        } catch (error) {
            console.error('查询支付结果失败:', error)
            // 网络错误时，继续轮询，但记录错误
        }
    }, POLLING_CONFIG.INTERVAL)
}
//

const isClient = ref(false)

onMounted(async () => {
    if (route?.query?.biz_order_id) {
        query_biz_order_id.value = route?.query?.biz_order_id as string
    }

    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            // 确保注册完成后再设置 isClient，避免组件在注册前渲染
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            // 即使加载失败也设置为 true，避免无限等待
            isClient.value = true
        }
    }
    emitter.on('check-pay-result', showVisible)
})

onUnmounted(() => {
    emitter.off('check-pay-result', showVisible)
})

watch(
    () => visible.value,
    newVal => {
        console.log('newVal', newVal)
        if (!newVal) {
            pay_result_status.value = ''
            clearPollingTimer()
            resetUrlPayStatus(PAYMENT_STATUS.CANCELLED)
            // 清理已上报订单ID记录（可选，如果希望每次打开弹窗都重新记录）
            // reportedOrderIds.value.clear()
        }
    }
)

watch(
    () => query_biz_order_id.value,
    newVal => {
        if (newVal) {
            handlePayResultPolling(newVal)
        }
    }
)

watch(
    () => pendingOrderVisible.value,
    newVal => {
        if (!newVal) {
            clearPollingTimer()
        }
    }
)
</script>

<style scoped lang="less">
/* 自定义动画 */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

.fixed {
    animation: fadeIn 0.3s ease-out;
}

.recharge-btn {
    background: theme('backgroundColor.active-bg');
}

:deep(.el-loading-mask) {
    background: transparent;
}

.pay-loading {
    animation: loading-animation 2.5s infinite;
}

@keyframes loading-animation {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

.shake-animation {
    animation: shake-animation 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);
}

@keyframes shake-animation {
    0% {
        transform: translateX(0);
    }
    25% {
        transform: translateX(-20px);
    }
    50% {
        transform: translateX(0);
    }
    75% {
        transform: translateX(20px);
    }
    100% {
        transform: translateX(0);
    }
}
</style>
